<template>
  <div data-w-id="448c0df2-8fda-b42f-7c4e-044c21a776a2" class="contact">
    <div id="contact" class="anchor is--footer"></div>
    <div class="w-layout-hflex global--padding">
      <div class="global--wrapper is--footer">
        <div class="footer--header">
          <h2 class="h--large is--white v--2" v-html="$t('footer.NEED OUR TEAM HELP?')"></h2>
          <div class="v-sep">
            <div class="inner--line--right"></div>
          </div>
        </div>
        <div class="footer-contacts--wrapper" style="width: 100%">
          <!-- <div class="w-layout-vflex contact--wrapper">
            <div class="text--chip is--yellow">{{ $t("Call") }}</div>
            <a href="tel:+420773645226" class="contact--link w-inline-block">
              <div>+420 773 645 226</div>
              <div class="link--underline">
                <div class="link--inner--lightline"></div>
              </div>
            </a>
          </div> -->
          <div class="w-layout-vflex contact--wrapper">
            <div class="text--chip is--yellow">{{ $t("Email") }}</div>
            <a href="mailto:support@swipez.eu" class="contact--link w-inline-block">
              <div>support@swipez.eu</div>
              <div class="link--underline">
                <div class="link--inner--lightline"></div>
              </div>
            </a>
          </div>
          <div
            style="
              margin-left: auto;
              max-width: 220px;
              display: flex;
              align-items: center;
              padding-top: 20px;
            "
          >
            <div style="width: 70px">
              <img src="@/assets/img/card-visa.png" />
            </div>
            <div style="width: 60px">
              <img src="@/assets/img/card-master.png" />
            </div>
          </div>
        </div>

        <div class="copy">
          <div class="w-layout-hflex disclaimer">
            <div class="copy-p">
              Copyright © 2025 Draph Solutions s.r.o. <br />All Rights Reserved
            </div>

            <div class="div-block-7">
              <a href="/privacy-policy" target="_blank" class="footer--link w-inline-block">
                <div>{{ $t("footer.Privacy Policy") }}</div>
              </a>
              <a href="/terms-and-conditions" target="_blank" class="footer--link w-inline-block">
                <div>{{ $t("footer.Terms and Conditions") }}</div>
              </a>
              <a href="/complaints-disclaimer" class="footer--link w-inline-block">
                <div>{{ $t("footer.Complaints Disclaimer") }}</div>
              </a>
              <a href="/safeguarding-disclaimer" class="footer--link w-inline-block">
                <div>{{ $t("footer.Safeguarding Disclaimer") }}</div>
              </a>
              <!-- <a href="/cryptocurrency-exchange-notice" class="footer--link w-inline-block">
								<div>Cryptocurrency Exchange Notice</div>
							</a> -->
            </div>
          </div>
          <div class="w-layout-hflex footer--nav">
            <div class="disclaimer--p">
              {{ $t("footer.All rights reserved") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LocaleSwitcher from "@/locales/LocaleSwitcher.vue";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});
</script>

<style scoped lang="scss">
.footer-contacts--wrapper {
  flex-wrap: wrap;
}
</style>
